import React, {Component} from 'react';
import {connect} from 'react-redux';
import {NavBar, DataTables, BreadCumb,TimeOut,CreateQueryManagerModal,InventoryDataModal} from '../../components';
import {DISPATCH_ID, SERVICE_RESPONSE} from '../../libs/utils/Const';
import {ApiClient, ApiResponse} from '../../libs/apiClient';
import config from '../../config';
import moment from 'moment';


import $ from "jquery";
import InventoryReportsModal from '../../components/InventoryReportsModal';

let apiClient = ApiClient.getInstance();

class InventoryReportsView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            updateData: false,
            data: [],
            total: 0,
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'))
        }
    }

    async componentDidMount(filter): void {
        localStorage.setItem(config.localStorageNamed + 'toogleNavBarItem', "liInventoryReports");
        //await this.callDocumentsListService();
    }
//Buscar inventarios
    searchItems = async filter => {
        await this.callDocumentsListService(filter);
    };
//Listar Documentos por Filtros
    callDocumentsListService = async (filter = { priceValue: '---', groupCodeValue: '---'}) => {
        const { enableSpinner } = this.props;
        enableSpinner(true);
        let inventoryDataResponse = await apiClient.getItemsrList(filter);
        enableSpinner(false);
        if(inventoryDataResponse.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                data: inventoryDataResponse.data.partners,
                total:inventoryDataResponse.data.totalRows
            });
        }
    };
//////
createManagerDocument = () => {
    $('#InventoryReportsModal').modal({backdrop: 'static', keyboard: false}, 'show');
};

createManagerDocument = async () => {

    const { notificationReducer: {showAlert}, enableSpinner} = this.props;

    enableSpinner(true);
    let getQueryManagerResponse = await apiClient.getSearchFormater();
   
    enableSpinner(false);
    

    if (!Array.isArray(getQueryManagerResponse.data.searchFormater)) {
        showAlert({type: 'error', message: 'Ocurrió un error al consultar la Información'});
        return;
    }

    if (getQueryManagerResponse.data.length === 0) {
        showAlert({type: 'info', message: 'No hay Información por mostrar'});
        return;
    }

    this.setState({
        query: getQueryManagerResponse.data/*,
        querySubCategories: getQueryManagerResponse2.data,*/
    });
    $('#InventoryReportsModal').modal({backdrop: 'static', keyboard: false}, 'show');
};

    render() {
        const {data, updateData,total,_user} = this.state; 

        const { notificationReducer: {showAlert}, enableSpinner,newOrderModel}= this.props
        const {query}= this.state
        return (
            <div className="content">
                <NavBar props={this.props} _user={_user} />
                <TimeOut/>
                <InventoryReportsModal 
                showAlert={showAlert}
                enableSpinner = {enableSpinner}
                />
                <BreadCumb subitem1={'INFORMES DE INVENTARIO'} url1={'#'}/>
                <div style={{marginLeft: "4rem", marginBottom: "12rem"}}>

                    <h2 className="md-display-1">
                        <a id="liInventoryReports" className="text-muted">
                            &nbsp;INFORMES DE INVENTARIO 
                        </a>
                    </h2>
                    <div className='form-row'>
                        <br className="hide-pc"/>
                        <button className="btn btn-outline-secondary btn-timbra-one" 
                            style={{width:250, borderColor: "#A7A6A5"}} onClick={this.createManagerDocument}>
                            <i className="far fa-file"></i> Informe de Auditoría de Stocks
                        </button>
                    </div>
                    {/* <DataTables view={"inventoryReports"} data={data} search={this.searchItems} totalRows={total}/> */}
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return {notificationReducer: store.NotificationReducer};
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({type: DISPATCH_ID.CONFIG_SET_SPINNER, value})
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InventoryReportsView);
